export default {
  common: {
    breadcrumb: {
      home: 'ホーム',
    },
    learnMore: '詳細はこちら',
  },
  heroTitle: 'IFS ソリューション',
  heroSubtitle: 'IFS Solutions',
  heroImagePC: 'ifs/bg-pc.png',
  heroImageSP: 'ifs/bg-sp.png',
  heroPartner: 'ifs/partner.png',
  heroDesc:
    'IFSは、企業のデジタルトランスフォーメーション（DX）における中核的な基盤です。ERP、EAM、FSMなどの基幹システムを緊密に統合し、AI、IoT、ロボティクス技術を融合させることで、'
    + '計画から実装に至るまでの一貫したデジタルソリューションを提供し、企業の効率的な運営とインテリジェント化の実現を支援します。',
  corporatePartnerships: {
    title: '飛狼数碼（上海）有限公司はIFSの大中華圏正規総代理',
    link: {
      label: 'IFSソリューション公式サイト',
      path: 'https://www.ifs.com/ja',
    },
  },
  intro: [
    'IFSは、ERP、EAM、FSMといった中核となる業務機能を基盤として、企業運営、資産管理、フィールドサービスを統合し、さらにAI（人工知'
    + '能）やインテリジェント・オートメーションを活用することで、企業運営能力を一層向上させます。',
    'このプラットフォームは、企業の主要な業務プロセスとデータを統合し、一元管理、リアルタイムな連携、およびインテリジェントな意思決定の実現を支援します。',
    '当社は、IFSプラットフォーム、業界の知見、そしてAI技術を融合させ、コンサルティング・計画策定からシステム導入、統合開発に至るまで、'
    + '企業のデジタル化に向けたソリューションを提供し、業務プロセスの最適化と企業のインテリジェント化を継続的に推進します。',
  ],
  solutionsTitle: 'ソリューション',
  solutionsSubtitle: 'Our Solutions',
  solutions: [
    {
      icon: 'si/si-icons/database.svg',
      title: 'ERP 企業資源計画',
      desc:
        '企業の財務、調達、生産、販売、人事などの主要な業務プロセスを統合し、データの統合管理とリアルタイムな意思決定支援を実現することで、業務効率を向上させます。',
      path: 'https://www.ifs.com/ja/products/erp',
    },
    {
      icon: 'si/si-icons/wrench.svg',
      title: 'EAM 企業資産管理',
      desc:
        '資産のライフサイクル全体を網羅的に管理し、調達・入庫から運用・保守、廃棄に至るまで、予防保全、作業指示管理、コンプライアンス監査を実現することで、設備のダウンタイムと保守コストを削減します。',
      path: 'https://www.ifs.com/ja/products/alm/eam',
    },
    {
      icon: 'ifs/user.svg',
      title: 'FSM 現場サービス管理',
      desc:
        '作業指示管理、人員の配備・割り当て、現場作業、設備保守などの業務プロセスを統合し、サービスリソースの一元管理とリアルタイムな連携を実現することで、フィールドサービスの効率と顧客満足度を向上させます。',
      path: 'https://www.ifs.com/ja/products/fsm',
    },
    {
      icon: 'ifs/vector.svg',
      title: '企業 AI ソリューション',
      desc:
        'AIと企業の基幹業務プロセスを融合させ、インテリジェントな予測、データ分析、自動化処理、意思決定支援を通じて、企業データをビジネス上の洞察へと変換します。これにより、リソース配分の最適化や業務効率の向上'
        + 'を支援し、よりスマートで効率的な企業経営を実現します。',
      path: 'https://www.ifs.com/ja/products/ai',
    },
  ],
  scenariosTitle: '適用シーン',
  scenariosSubtitle: 'Use Cases',
  scenariosDescription: 'IFSは、さまざまな業界に対し、業務特性に適合したデジタルソリューションを提供しています。',
  scenarios: [
    {
      icon: 'si/si-icons/factory.svg',
      title: '製造業',
      titleEn: 'Manufacturing',
      desc: '完成車組立ラインにおけるリアルタイムのタクトタイム管理、部品トレーサビリティ、品質ゲート管理を実現し、生産効率を15%以上向上させました。',
    },
    {
      icon: 'ifs/aerospace.svg',
      title: '航空宇宙・防衛',
      titleEn: 'Aerospace & Defense',
      desc: '複雑な製品、資産、サプライチェーンの管理ニーズに対応し、生産から保守に至るライフサイクル全体にわたる管理を実現します。',
    },
    {
      icon: 'ifs/energy.svg',
      title: 'エネルギー・公益事業',
      titleEn: 'Energy & Utilities',
      desc: '主要資産、保守計画、およびフィールドサービスを軸に、資産のライフサイクル全体にわたる管理と効率的な運用を実現します。',
    },
    {
      icon: 'ifs/engineering.svg',
      title: 'エンジニアリングと建築',
      titleEn: 'Engineering & Construction',
      desc:
        'プロジェクト管理、調達、コスト管理、現場作業を統合し、計画から引き渡しに至る全プロセスの管理を実現することで、プロジェクトの遂行効率とリソース利用率を向上させます。',
    },
    {
      icon: 'ifs/telecommunications.svg',
      title: '電気通信',
      titleEn: 'Telecommunications',
      desc:
        'ネットワーク資産、フィールドサービス、要員の配備、および保守プロセスを統合し、サービスリソースの効率的な連携を実現することで、サービスへの対応速度と運用効率を向上させます。',
    },
    {
      icon: 'ifs/transportation.svg',
      title: '交通・運輸',
      titleEn: 'Transportation',
      desc:
        '資産、保守、配車、および運行管理を統合し、リアルタイムデータとAI予測を活用することで、輸送企業の資産信頼性、運行効率、サービス品質を向上させます。',
    },
  ],
  learnMoreFenrir: {
    title: '「飛狼」の事業について、ぜひ詳しくご覧ください',
    contact: 'お問い合わせ',
  },
};
